import agent from '../agent'
import React from 'react'
import { connect } from 'react-redux'
import { Route, Switch, Link, withRouter } from 'react-router-dom'

import Login from './Login'
import Verification from '../components/Verification'
import PhoneLogin from '../components/PhoneLogin'
import ResetPassword from './ResetPassword'
import VerifyResetPassword from './VerifyResetPassword'
import Register from './Register'
import RegisterManager from './RegisterManager'

import Home from './Home'
import RegisterVerifyPhone from './RegisterVerifyPhone'
import RegisterSuccess from './RegisterSuccess'
import Pending from './Pending'
import Dashboard from './Dashboard'
import Settings from './Settings'
import Groups from './Groups'
import GroupAdd from './GroupAdd'
import GroupDetail from './GroupDetail'

import DirectoryAdd from './DirectoryAdd'
import DirectoryEdit from './DirectoryEdit'
import Files from './Files'
import Upload from './Upload'
import FileDetail from './FileDetail'
import Logs from './Logs'

import LangTools from './widgets/LangTools'
import Confirm from '../components/Confirm'
import ErrorBoundary from './ErrorBoundary'
import { store } from '../store'
import { push } from 'react-router-redux'
import {
  REACT_APP_SITE_NAME,
  REACT_APP_ORG_NAME,
  REACT_APP_SITE_SYMBOL,
  REACT_APP_INACTIVITY_LOGOUT_ENABLED,
  REACT_APP_INACTIVITY_LOGOUT_TIME_IN_MINUTES,
  REACT_APP_SITE_DOWN
} from '../constants/config'
import { Helmet } from "react-helmet"
import role from '../util/role';
import {
  APP_LOAD,
  LOGOUT,
  REDIRECT,
  GRAPH_LOAD,
  BOOK_LOAD,
  TRANSACTION_STATS_LOAD,
  GROUP_LIST_PAGE_LOADED,
  LOG_LIST_PAGE_LOADED
} from '../constants/actionTypes'

const getTradingpair = (traingLabel) => {
  return traingLabel.replace('/', '')
}
const mapStateToProps = state => {
  return {
    appLoaded: state.common.appLoaded,
    appName: state.common.appName,
    orgName: state.common.orgName,
    currentUser: state.common.currentUser,
    redirectTo: state.common.redirectTo,
    token: state.common.token
  }
}

const mapDispatchToProps = dispatch => ({
  onLoad: (payload, token) =>
    dispatch({ type: APP_LOAD, payload, token, skipTracking: true }),
  onRedirect: () =>
    dispatch({ type: REDIRECT }),
  onClickLogout: () => dispatch({ type: LOGOUT }),
})

class App extends React.Component {
  constructor() {
    super()
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo) {
      store.dispatch(push(nextProps.redirectTo))
      this.props.onRedirect()
    }
  }

  async componentWillMount() {
    const token = window.localStorage.getItem('pellar-file-web-token')
    if (token) {
      agent.setToken(token)
    }
    const payload = Promise.all([
      agent.Common.getConfigs(),
      token ? agent.Auth.current() : null
    ])

    this.props.onLoad(payload, token)

  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo) {
      store.dispatch(push(nextProps.redirectTo))
      this.props.onRedirect()
    }
  }
  refreshData() {
  }
  componentDidMount() {
    if (REACT_APP_INACTIVITY_LOGOUT_ENABLED) {
      const currentTime = new Date().getTime()
      this.setState({ lastActivityTime: currentTime })
      window.addEventListener('mouseover', this.handleMouseover.bind(this))
      window.addEventListener('scroll', this.handleScroll.bind(this))
      this.inactivityCheck()
    }
    this.refreshData()

  }
  handleMouseover = e => {
    //console.log('mouseover event:', e)
    let lastActivityTime = new Date().getTime()
    this.setState({ lastActivityTime: lastActivityTime })
  }
  handleScroll = e => {
    // console.log('brower scroll event:', e)
    let lastActivityTime = new Date().getTime()
    this.setState({ lastActivityTime: lastActivityTime })
  }
  inactivityCheck() {
    const maxTime = REACT_APP_INACTIVITY_LOGOUT_TIME_IN_MINUTES * 60 * 1000
    this.inactivityTimer = setInterval(() => {
      const currentTime = new Date().getTime()
      const lastActivityTime = this.state.lastActivityTime

      // console.log(`currentTime:${currentTime},lastActivityTime:${lastActivityTime}`)
      if (currentTime - lastActivityTime > maxTime) {
        if (this.props.currentUser) {
          this.props.onClickLogout()
        }
      }
    }, 1000 * 10);//check  inactivity every 10 seconds
  }
  componentWillUnmount() {
    if (REACT_APP_INACTIVITY_LOGOUT_ENABLED) {
      window.removeEventListener('mouseover', this.handleMouseover.bind(this))
      window.removeEventListener('scroll', this.handleScroll.bind(this))
    }
  }
  render() {
    if (REACT_APP_SITE_DOWN) {
      return (
        <div>
          <div id="modal" class='maintenance'>
            <h1>{REACT_APP_SITE_NAME}</h1>
            <div>The Pellar File is currently offline for scheduled maintenance.</div>
            <div>The site will be available again shortly, once maintenance is completed.</div>
            <div>If you have any enquiries please send an email to support@pellartech.com</div>
          </div>
        </div>
      )
    }
    if (this.props.appLoaded) {
      let applicationVersion

      try { applicationVersion = process.env.npm_package_version || require('../../package.json').version } catch (err) { applicationVersion = 'N/A' }

      const icoUrl = `/favicon/favicon_${REACT_APP_SITE_SYMBOL.toLowerCase()}.ico`
      const clientCSSUrl = `/style/${REACT_APP_SITE_SYMBOL.toLowerCase()}.css?v=${applicationVersion}`
      const siteName = REACT_APP_SITE_NAME
      const orgName = REACT_APP_ORG_NAME
      const userRole = this.props.currentUser ? (this.props.currentUser.role || 0) : 0;

      return (
        <div id="site-wrap">
          <Helmet>
            <title>{siteName}</title>
          </Helmet>
          <ErrorBoundary>
            <Switch>
              <Route exact path="/" component={Login} />
              <Route path="/login" component={Login} />
              <Route path="/verification" component={Verification} />
              <Route path="/phonelogin" component={PhoneLogin} />
              <Route path="/restpassword" component={ResetPassword} />
              <Route path="/verifyresetpassword" component={VerifyResetPassword} />
              <Route path="/register/verifyphone" component={RegisterVerifyPhone} />
              <Route path="/register/complete" component={RegisterSuccess} />
              <Route path="/register/manager" component={RegisterManager} />
              <Route path="/register" component={Register} />
              <Route path="/pending" component={Pending} />
              <Route path="/dashboard" component={Dashboard} />
              <Route exact path="/settings" component={Settings} />

              <Route exact path="/directories/add" component={DirectoryAdd} />
              <Route exact path="/directories/:key/edit" component={DirectoryEdit} />
              <Route exact path="/files/:key" component={FileDetail} />
              <Route exact path="/files" component={Files} />
              <Route exact path="/upload" component={Upload} />
              {role.can(userRole, GROUP_LIST_PAGE_LOADED) ? <Route exact path="/groups" component={Groups} /> : null}
              {role.can(userRole, GROUP_LIST_PAGE_LOADED) ? <Route exact path="/groups/add" component={GroupAdd} /> : null}
              {role.can(userRole, GROUP_LIST_PAGE_LOADED) ? <Route exact path="/groups/:key" component={GroupDetail} /> : null}
              {role.can(userRole, LOG_LIST_PAGE_LOADED) ? <Route exact path="/logs" component={Logs} /> : null}
              <Route path="/confirm" component={Confirm} />
            </Switch>
          </ErrorBoundary>
          <LangTools currentUser={this.props.currentUser} token={this.props.token} />
        </div>
      )
    }
    return (
      <div id="modal">
        <h1>File Management</h1>
      </div>
    )
  }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
